<template>
  <div class="view-container text-center">
    <div class="text-right cursor-pointer">
      <b-button
        variant="link"
        @click="back"
      >
        <font-awesome-icon icon="times" />
      </b-button>
    </div>
    <!-- <loading-spinner v-if="loading" /> -->
    <template>
      <div class="row justify-content-between px-3 mb-4">
        <img
          src="../assets/images/logo-comune.png"
          style="height:80px"
        >
        <div class="p-5">
          <span
            v-if="incarico.numeroProtocollo"
            class="protocollo ml-3"
          >
            N. reg. {{ incarico.numeroProtocollo }}
          </span>
        </div>
      </div>
      <h2 class="text-center mt-3 text-uppercase">MODULO RICHIESTA ABILITAZIONE ALL’UTILIZZO DEI SERVIZI</h2>
      <h2 class="text-center mt-3 text-uppercase"> DEL PORTALE PATRIMONIO DI ROMA CAPITALE</h2>
      <div class="text-center mb-3"> (ai sensi del D.Lgs 7 marzo 2005, n. 82 e ss.mm.ii.)</div>
      <div class="titolo">
        <p class="text-justify px-4 mt-3">TITOLARE RAPPORTO/I DI UTENZA</p>
      </div>
      <b-form
        inline
        class="mb-3"
      >

        <template v-if="incarico.titolare">
          <p class="text-justify px-4 mb-3">
            <span class="mr-1 mt-3">Cognome e Nome/Denominazione</span>
            <b-input
              v-model.trim="incarico.titolare.nominativo"
              type="text"
              :formatter="formatUcase"
              class="form-field"
              :state="fieldState('nominativo')"
              readonly
            />
            <!-- <b-form-invalid-feedback v-if="!$v.incarico.titolare.nominativo.required">Campo obbligatorio</b-form-invalid-feedback> -->
            <span class="ml-3 mr-1">Codice Fiscale</span>
            <b-input
              v-model="incarico.titolare.codiceFiscale"
              type="text"
              :formatter="formatUcase"
              class=" form-field mr-3"
              :state="fieldCodiceFiscale"
              readonly
            /><br>
            <!-- <b-form-invalid-feedback v-if="!$v.titolare.codiceFiscale.required">Campo obbligatorio</b-form-invalid-feedback> -->
            <!-- <b-form-invalid-feedback v-if="!$v.incarico.titolare.codiceFiscale.codiceFiscale">Codice fiscale non corretto</b-form-invalid-feedback> -->
          </p>
          <p class="text-justify px-4 mb-3">
            <span class="mr-1">Email/Pec</span>
            <b-input
              :disabled="!isOpen"
              v-model.trim="incarico.titolare.email"
              type="email"
              class="form-field mr-3"
              :state="fieldEmail"
            />
            <!-- <b-form-invalid-feedback v-if="!$v.incarico.titolare.email.required">Campo obbligatorio</b-form-invalid-feedback> -->
            <!-- <b-form-invalid-feedback v-if="!$v.incarico.titolare.email.email">Indirizzo email non valido</b-form-invalid-feedback> -->
            <span class="ml-3 mr-1">Cellulare</span>
            <b-input
              :disabled="!isOpen"
              v-model.trim="incarico.titolare.cellulare"
              type="text"
              :formatter="formatUcase"
              trim
              class="form-field mr-3"
              :state="fieldNumeroMobile"
            />
            <!-- <b-form-invalid-feedback v-if="!$v.incarico.titolare.cellulare.required">Campo obbligatorio</b-form-invalid-feedback> -->
            <!-- <b-form-invalid-feedback v-if="!$v.incarico.titolare.cellulare.mobileValidate">Numero mobile non valido</b-form-invalid-feedback> -->
            <span class="ml-3 mr-1">RU</span>
            <b-input
              v-model.trim="incarico.titolare.codiceUtente"
              type="text"
              :formatter="formatUcase"
              class="form-field mr-3"
              style="width:10rem"
              :state="fieldState('codiceUtente')"
              readonly
            /><br>
            <!-- <b-form-invalid-feedback v-if="submitted && !$v.titolare.codiceUtente.required">Campo obbligatorio</b-form-invalid-feedback> -->
          </p>
          <p class="text-justify px-4">
            <span class="mr-1">BU (unità immobiliare)</span>
            <b-input
              v-model.trim="incarico.titolare.codiceUib"
              type="text"
              :formatter="formatUcase"
              class="form-field mr-3"
              :state="fieldState('codiceUib')"
              readonly
            /><br>
            <!-- <b-form-invalid-feedback v-if="submitted && !$v.titolare.codiceUib.required">Campo obbligatorio</b-form-invalid-feedback> -->
          </p>
        </template>
        <div class="col-12 col-md-12 titolo mt-3">
          <p class="text-justify mt-3">OPERAZIONE RICHIESTA</p>
        </div>
        <div
          role="group"
          class="col-12 col-md-12 text-justify px-4 stack-label"
        >
          <b-form-radio-group>
            <b-form-radio
              :disabled="!isOpen"
              v-model="incarico.abilitazione"
              value="nuova"
              name="some-radios"
              @change="changeAbilitazione"
            >Nuova abilitazione (*)</b-form-radio>
            <span class="ml-3">fino a data: </span>
            <b-input
              :disabled="incarico.abilitazione === 'disabilitazione' || !isOpen"
              v-model="incarico.fineAbilitazione"
              type="date"
              class="mr-3"
            />
            <b-form-radio
              :disabled="!isOpen"
              class="ml-3"
              v-model="incarico.abilitazione"
              value="disabilitazione"
              name="some-radios"
              @change="changeAbilitazione"
            >Disabilitazione (**)</b-form-radio>
          </b-form-radio-group>
          <b-form-invalid-feedback
            class="spunta"
            v-if="submitted && incarico.abilitazione === ''"
          >Attenzione è necessario effettuare una scelta</b-form-invalid-feedback>
        </div>
        <div
          role="group"
          class="col-12 col-md-2"
        ></div>
        <div
          role="group"
          class="col-12 col-md-12 mt-3"
        >
          <p class="text-justify">(*) L’abilitazione si intende concessa, a seguito di esito di istruttoria favorevole, per un periodo di 12 mesi dalla data di
            presentazione della richiesta o per il più limitato periodo indicato.
          </p>
          <p class="text-justify">(**) Il titolare del Rapporto di Utenza può, in qualsiasi momento, procedere alla revoca delle abilitazioni concesse.
            La richiesta di disabilitazione può essere presentata anche dal soggetto persona fisica precedentemente incaricato o
            dal nuovo soggetto persona fisica che intende abilitarsi come incaricato di soggetto diverso da persona fisica.
          </p>
        </div>
        <div class="col-12 col-md-12  mt-4 titolo">
          <p class="text-justify">DATI IDENTIFICATIVI DELL’INCARICATO E DICHIARAZIONE SOSTITUTIVA ATTO NOTORIETÀ (ai sensi dell’art.47
            D.P.R. 28 dicembre 2000, n.445)</p>
        </div>
        <div class="titolo">
          <p class="text-justify px-4 mt-3">Il/La sottoscritto/a:</p>
        </div>
        <div class="col-12 col-md-12"></div>
        <template v-if="incarico.incaricato">
          <p class="text-justify px-4">
            <span class="mr-1">Cognome e Nome</span>
            <b-input
              :disabled="!isOpen"
              v-model.trim="incarico.incaricato.nominativo"
              type="text"
              :formatter="formatUcase"
              class=" form-field"
              :state="fieldStateIncaricato('nominativo')"
            />
            <!-- <b-form-invalid-feedback v-if="submitted && !$v.incaricato.nominativo.required">Campo obbligatorio</b-form-invalid-feedback> -->
            <span class="ml-3 mr-1">Codice Fiscale</span>
            <b-input
              :disabled="!isOpen"
              v-model.trim="incarico.incaricato.codiceFiscale"
              type="text"
              :formatter="formatUcase"
              class=" form-field mr-3"
              :state="fieldCodiceFiscaleIncaricato"
            />
            <!-- <b-form-invalid-feedback v-if="!$v.incarico.incaricato.codiceFiscale.required">Campo obbligatorio</b-form-invalid-feedback> -->
            <!-- <b-form-invalid-feedback v-if="!$v.incarico.incaricato.codiceFiscale.codiceFiscale">Codice fiscale non corretto</b-form-invalid-feedback> -->
          </p>
          <p class="text-justify px-4 mt-3">
            <span class="mr-1">Via</span>
            <b-input
              :disabled="!isOpen"
              v-model.trim="incarico.incaricato.via"
              type="text"
              :formatter="formatUcase"
              class="form-field mr-3"
              :state="fieldStateIncaricato('via')"
            />
            <!-- <b-form-invalid-feedback v-if="submitted && !$v.incaricato.via.required">Campo obbligatorio</b-form-invalid-feedback>  -->
            <span class="ml-3 mr1">Cap</span>
            <b-input
              :disabled="!isOpen"
              v-model.trim="incarico.incaricato.cap"
              :formatter="formatUcase"
              class=" form-field mr-3"
              size="sm"
              :state="fieldStateIncaricato('cap')"
            />
            <!-- <b-form-invalid-feedback v-if="!$v.incarico.incaricato.cap.required">Campo obbligatorio</b-form-invalid-feedback> -->
            <span class="ml-3 mr1">Comune</span>
            <b-input
              :disabled="!isOpen"
              v-model.trim="incarico.incaricato.comune"
              type="text"
              :formatter="formatUcase"
              size="sm"
              class="form-field mr-3"
              :state="fieldStateIncaricato('comune')"
            />
            <!-- <b-form-invalid-feedback v-if="!$v.incarico.incaricato.comune.required">Campo obbligatorio</b-form-invalid-feedback> -->
          </p>
          <p
            class="text-justify px-4 mt-3"
            v-if="incarico.incaricato"
          >
            <span class="mr-1">Provincia</span>
            <b-input
              :disabled="!isOpen"
              v-model.trim="incarico.incaricato.provincia"
              type="text"
              :formatter="formatUcase"
              class="form-field mr-3"
              style="width:8rem"
              :state="fieldStateIncaricato('provincia')"
            />
            <!-- <b-form-invalid-feedback v-if="!$v.incarico.incaricato.provincia.required">Campo obbligatorio</b-form-invalid-feedback> -->
            <span class="ml-3 mr-1">Email/Pec</span>
            <b-input
              :disabled="!isOpen"
              v-model.trim="incarico.incaricato.email"
              type="text"
              class="form-field"
              :state="fieldEmailIncaricato"
            />
            <!-- <b-form-invalid-feedback v-if="!$v.incaricato.email.required">Campo obbligatorio</b-form-invalid-feedback> -->
            <!-- <b-form-invalid-feedback v-if="!$v.incarico.incaricato.email.email">Indirizzo email non valido</b-form-invalid-feedback> -->
            <span class="ml-1 mr-1">Cellulare</span>
            <b-input
              :disabled="!isOpen"
              v-model.trim="incarico.incaricato.cellulare"
              type="text"
              :formatter="formatUcase"
              class="form-field mr-3"
              :state="fieldNumeroMobileIncaricato"
            />
            <!-- <b-form-invalid-feedback v-if="!$v.incaricato.cellulare.required">Campo obbligatorio</b-form-invalid-feedback> -->
            <!-- <b-form-invalid-feedback v-if="!$v.incarico.incaricato.cellulare.mobileValidate">Numero mobile non valido</b-form-invalid-feedback> -->
          </p>
        </template>
        <div
          role="group"
          class="col-12 col-md-12 ml-2 mt-3"
        >
          <p class="titolo text-justify mt-3">Dichiara (barrare la casella che interessa):</p>
        </div>
        <div
          role="group"
          class="col-12 col-md-12 ml-2"
        >
          <p class="text-justify">di essere rappresentante</p>
        </div>
        <div
          role="group"
          class="col-12 col-md-12 text-justify px-4 stack-label"
        >
          <b-form-radio-group>
            <b-form-radio
              :disabled="!isOpen"
              v-model="incarico.incaricato.rappresentante"
              value="legale"
              name="some-radios"
              @change="changeRappresentante"
            >legale</b-form-radio>
            <b-form-radio
              :disabled="!isOpen"
              v-model="incarico.incaricato.rappresentante"
              value="negoziale"
              name="some-radios"
              @change="changeRappresentante"
            >negoziale del titolare del rapporto/i di utenza</b-form-radio>
          </b-form-radio-group>
          <b-form-invalid-feedback
            class="spunta"
            v-if="submitted && incarico.incaricato.rappresentante === ''"
          >Attenzione è necessario effettuare una scelta</b-form-invalid-feedback>
        </div>
        <div
          role="group"
          class="col-12 col-md-12 ml-2 mt-3"
        >
          <p class="titolo text-justify mt-3">Si impegna:</p>
        </div>
        <b-form
          inline
          class="text-justify px-4 mt-1"
        >
          <b-form-checkbox
            :disabled="!isOpen"
            v-model="terminidiUtilizzo.misureIdonee"
            required
          >ad adottare, nell’utilizzo dei servizi del Portale, tutte le misure organizzative e tecniche idonee ad evitare
            danno ad altri
          </b-form-checkbox>
          <b-form-invalid-feedback
            class="spunta"
            v-if="submitted && terminidiUtilizzo.misureIdonee === false"
          >Campo obbligatorio</b-form-invalid-feedback>
        </b-form>
        <b-form
          inline
          class="text-justify px-4 mt-3"
        >
          <b-form-checkbox
            :disabled="!isOpen"
            v-model="terminidiUtilizzo.riservatezza"
          >
            a garantire l’obbligo di riservatezza delle informazioni trattate, anche per conto dei soggetti designati
            come responsabili del trattamento dei dati personali, ottemperando alla normativa vigente in materia di
            privacy e di protezione dei dati personali
          </b-form-checkbox>
          <b-form-invalid-feedback
            class="spunta"
            v-if="submitted && terminidiUtilizzo.riservatezza === false"
          >Campo obbligatorio</b-form-invalid-feedback>
        </b-form>
        <b-form
          inline
          class="text-justify px-4 mt-3"
        >
          <b-form-checkbox
            :disabled="!isOpen"
            v-model="terminidiUtilizzo.divulgazione"
          >
            a non divulgare e/o comunque a non rendere note a soggetti terzi le informazioni riservate, intendendosi
            per soggetti terzi tutti i soggetti diversi da quelli autorizzati;
          </b-form-checkbox>
          <b-form-invalid-feedback
            class="spunta"
            v-if="submitted && terminidiUtilizzo.divulgazione === false"
          >Campo obbligatorio</b-form-invalid-feedback>
        </b-form>
        <b-form
          inline
          class="text-justify px-4 mt-3"
        >
          <b-form-checkbox
            :disabled="!isOpen"
            v-model="terminidiUtilizzo.sicurezza"
          >
            ad adottare tutte le cautele e le misure di sicurezza necessarie e opportune, secondo i migliori standard
            professionali, al fine di mantenere riservate le Informazioni, nonché al fine di prevenire accessi non
            autorizzati, sottrazione e manipolazione delle stesse;
          </b-form-checkbox>
          <b-form-invalid-feedback
            class="spunta"
            v-if="submitted && terminidiUtilizzo.sicurezza === false"
          >Campo obbligatorio</b-form-invalid-feedback>
        </b-form>
        <b-form
          inline
          class="text-justify px-4 mt-3"
        >
          <b-form-checkbox
            :disabled="!isOpen"
            v-model="terminidiUtilizzo.revoca"
          >
            a comunicare tempestivamente l’eventuale revoca dei poteri di rappresentanza conferiti all’incaricato dal
            soggetto giuridico titolare del rapporto/i di utenza ed a produrre conseguente richiesta di disabilitazione;
          </b-form-checkbox>
          <b-form-invalid-feedback
            class="spunta"
            v-if="submitted && terminidiUtilizzo.revoca === false"
          >Campo obbligatorio</b-form-invalid-feedback>
        </b-form>
        <b-form
          inline
          class="text-justify px-4 mt-3"
        >
          <b-form-checkbox
            :disabled="!isOpen"
            v-model="terminidiUtilizzo.variazioni"
          >
            <span>a comunicare ulteriori variazioni del contenuto della presente dichiarazione, rendendo, nel caso, una
              nuova dichiarazione sostitutiva.</span>
          </b-form-checkbox>
          <b-form-invalid-feedback
            class="spunta"
            v-if="submitted && terminidiUtilizzo.variazioni === false"
          >Campo obbligatorio</b-form-invalid-feedback>
        </b-form>
        <div
          role="group"
          class="col-12 col-md-12 ml-2 mt-3"
        >
          <p class="titolo text-justify mt-3">A tal fine allega (barrare la casella che interessa):</p>
        </div>
        <div
          class="text-justify px-4"
          @change="delegaAllegata"
        >
          <b-form-radio-group
            :disabled="!isOpen"
            v-model="incarico.documentazione"
            :options="options"
          ></b-form-radio-group>
          <b-form-invalid-feedback
            class="spunta"
            v-if="submitted && incarico.documentazione === ''"
          >Attenzione è necessario effettuare una scelta</b-form-invalid-feedback>
        </div>
        <div
          role="group"
          class="col-12 col-md-12 mt-3 ml-2"
        >
          <!-- <allegati-table
            :item="allegatiItem"
            :isModificato="isModificato"
          /> -->
          <allegati-table
            :item="allegatiItem"
            :fileAllegati="fileAllegati"
            :isModificato="isModificato"
          />

        </div>
        <div
          role="group"
          class="col-12 col-md-12 ml-2 mt-3"
        >
          <p class="small font-italic text-justify mx-4 mb-2">Il/la sottoscritto/a si impegna a fornire tutta la documentazione richiesta dall’Amministrazione per comprovare il possesso dei requisiti
            come sopra dichiarato. Il/la sottoscritto/a dichiara inoltre di essere consapevole che in caso di dichiarazione non veritiera decadrà dai
            benefici eventualmente ottenuti dal provvedimento emanato sulla base della dichiarazione stessa ai sensi dell’art. 75 del D.P.R. n. 445
            del 28/12/2000.</p>
        </div>
        <div
          role="group"
          class="col-12 col-md-12 ml-2 mt-3"
        >
          <p class="small font-italic text-justify mx-4 mb-2">Roma Capitale non assume alcuna responsabilità per quanto può derivare dall&#39;utilizzo da parte dell’incaricato del Portale Patrimonio
            e, in nessun caso, potrà essere ritenuta responsabile dei danni di qualsiasi natura causati direttamente o indirettamente dall&#39;accesso
            allo stesso, dall&#39;incapacità o impossibilità di accedervi, dall&#39;utilizzo delle notizie in esso contenute nè potrà essere ritenuta
            responsabile per eventuali danni derivanti dall’utilizzo improprio del potere di rappresentanza conferito.
          </p>
        </div>
        <div
          role="group"
          class="col-12 col-md-12 ml-2 mt-3"
        >
          <p class="small font-italic text-justify mx-4 mb-2">Ai sensi dell’ l’articolo 7 del Capo II e degli articoli 12-23 del Capo III del Regolamento Generale sulla Protezione dei Dati Personali
            (GDPR), il/la sottoscritto/a esprime il consenso al trattamento dei dati sottoscritti, anche sensibili, per le finalità ivi indicate e ad esso
            conseguenti; dichiara inoltre di essere stato adeguatamente informato e di essere a conoscenza della disponibilità dell’informativa
            completa, fornita da Roma Capitale, titolare del trattamento, ai sensi del GDPR, unitamente alle indicazioni relative ai diritti
            dell’interessato di cui all’art. 7 del medesimo decreto, pubblicata appositamente nel sito www.comune.roma.it
          </p>
        </div>
        <p
          class="text-left mt-5"
          v-if="incarico.dataConferma"
        >
          Roma,<span class="form-field">
            {{ moment(incarico.dataConferma).format('DD/MM/YYYY') }}
          </span>
        </p>

        <!-- <div role="group" class="col-12 col-md-6 mt-3">
            <p>
            Firma del richiedente<span class="form-field">
              </span>
          </p>
        </div> -->
      </b-form>
    </template>
    <div class="row mt-4 mx-2">

      <b-button
        v-if="isOpen"
        variant="success"
        class="m-2"
        xxxclick="handleSubmit"
        @click="doSaveConfirm"
      >
        <font-awesome-icon
          icon="check"
          class="text-white mr-2"
        />Salva e conferma
      </b-button>

      <b-button
        v-if="isOpen"
        variant="primary"
        class="m-2"
        @click="doSaveDraft"
      >
        <font-awesome-icon
          icon="save"
          class="text-white mr-2"
        />Salva in bozza
      </b-button>

      <b-button
        v-if="isOpen && incarico.stato === 'B'"
        variant="danger"
        class="m-2"
        @click="doDeleteDraftConfirm"
      >
        <font-awesome-icon
          icon="trash-alt"
          class="text-white mr-2"
        />Elimina bozza
      </b-button>

      <a
        target="_blank"
        v-if="!isOpen && incarico.stato !== 'P'"
        :href="urlIncarico"
      >
        <button class="btn btn-success m-2">
          <font-awesome-icon
            icon="download"
            class="text-white mr-2"
          />Scarica documento
        </button>
      </a>

      <b-button
        variant="outline-secondary"
        class="m-2"
        @click="back"
      >
        <font-awesome-icon
          icon="times"
          class="mr-2"
        />Chiudi
      </b-button>

    </div>
  </div>
</template>
<script>
import { required } from 'vuelidate/lib/validators'
// import cloneDeep from 'lodash/cloneDeep'
import 'numeral/locales'
import moment from 'moment'
import AllegatiTable from '@/components/AllegatiTableIncarico'

const mobileValidate = (value, vm) => {
  var re = /^((3[{1-9}][{0-9}]))([\d]{6,7})$/
  let retValue = false
  if (re.test(value)) {
    retValue = true
  }

  return retValue
}
const emailValidate = (value, vm) => {
  var re = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/
  let retValue = false
  if (re.test(value)) {
    retValue = true
  }
  return retValue
}
const codiceFiscale = (value, vm) => {
  var reCF = /[A-Za-z]{6}[0-9lmnpqrstuvLMNPQRSTUV]{2}[abcdehlmprstABCDEHLMPRST]{1}[0-9lmnpqrstuvLMNPQRSTUV]{2}[A-Za-z]{1}[0-9lmnpqrstuvLMNPQRSTUV]{3}[A-Za-z]{1}/
  var rePIVA = /[0-9]{11}/
  let retValue = false

  if (value.length === 16) {
    if (reCF.test(value)) {
      retValue = true
    }
  } else {
    if (rePIVA.test(value)) {
      retValue = true
    }
  }

  return retValue
}

const codiceFiscaleLengh = (value, vm) => {
  let retValue = false

  if (value.length === 16 || value.length === 11) {
    retValue = true
  }

  return retValue
}

const valueChecked = (value, vm) => {
  let retValue = false

  if (typeof value === 'string') {
    if (value === 'true') retValue = true
  } else {
    retValue = value
  }

  return retValue
}

const abilitazioneCheck = (value, vm) => {
  let retValue = false

  // console.log('abilitazioneCheck', value, vm)
  if (value === 'disabilitazione') {
    retValue = true
  } else if (value === 'nuova') {
    retValue = !!vm.fineAbilitazione
  }
  return retValue
}

export default {
  name: 'IncaricoForm',
  components: {
    AllegatiTable
  },
  data () {
    return {
      submitted: false,
      // allegatiStd: [{ 'idAllegato': 'a', 'descrizione': '', 'fileName': '', 'uploaded': '' }, { 'idAllegato': 'b', 'descrizione': "Copia documento d'identità", 'fileName': '', 'uploaded': '' }],
      fileAllegati: {},
      isModificato: true,
      terminidiUtilizzo: {
        misureIdonee: false,
        riservatezza: false,
        divulgazione: false,
        sicurezza: false,
        revoca: false,
        variazioni: false
      },
      incarico: {
        titolare: {},
        incaricato: {}
      },
      options: [
        { text: 'documentazione attestante la delega conferita al rappresentante legale della società', value: 'rappresentanteLegale' },
        { text: 'documentazione attestante la delega conferita al rappresentante negoziale del titolare dell’utenza', value: 'rappresentanteNegoziale' }
      ]
    }
  },

  validations: {
    incarico: {
      titolare: {
        nominativo: { required },
        codiceFiscale: { required, codiceFiscaleLengh, codiceFiscale },
        email: { required, emailValidate },
        cellulare: { required, mobileValidate },
        codiceUtente: { required },
        codiceUib: { required }
      },
      incaricato: {
        nominativo: { required },
        codiceFiscale: { required, codiceFiscaleLengh, codiceFiscale },
        via: { required },
        cap: { required },
        comune: { required },
        provincia: { required },
        email: { required, emailValidate },
        cellulare: { required, mobileValidate },
        rappresentante: { required }
      },
      abilitazione: { required, abilitazioneCheck },
      documentazione: { required },
      terminidiUtilizzo: {
        misureIdonee: { required, valueChecked },
        riservatezza: { required, valueChecked },
        divulgazione: { required, valueChecked },
        sicurezza: { required, valueChecked },
        revoca: { required, valueChecked },
        variazioni: { required, valueChecked }
      }
    }

  },
  /*   watch: {
     descrizione ( ) {
       console.log('item.incarico.documentazione', this.incarico.documentazione)
      if(this.incarico.documentazione === 'rappresentanteLegale') {
        this.item.allegati.descrizione = 'Delega rappresentante legale '
        console.log('this.item.allegati.descrizione', this.item.allegati.descrizione)
      }
      console.log('item.incarico.documentazione', this.incarico.documentazione)
    }
  }, */
  computed: {
    moment () {
      return moment
    },
    /* rows () {
      console.log('this.item', this.item.allegati)
      return this.item.allegati
    }, */
    allegatiItem () {
      return this.incarico
    },
    /*  descrizione () {
      console.log('this.item.allegati.descrizione', this.item.allegati.descrizione)
      this.item.allegati.descrizione = ''
      if (this.incarico.documentazione === 'rappresentanteLegale') {
        console.log('this.item.allegati.descrizione', this.item.allegati.descrizione)
        return this.item.allegati.descrizione = 'Delega rappresentante legale '

      }else {
        console.log('this.item.allegati.descrizione', this.item.allegati.descrizione)
        return this.item.allegati.descrizione = 'Delega prova'
      }
    }, */
    fieldNumeroMobile () {
      let retValue = null
      if (this.submitted) {
        this.$v.incarico.titolare.cellulare.$touch()
        retValue = !this.$v.incarico.titolare.cellulare.$invalid
      }
      return retValue
    },
    fieldNumeroMobileIncaricato () {
      let retValue = null
      if (this.submitted) {
        this.$v.incarico.incaricato.cellulare.$touch()
        retValue = !this.$v.incarico.incaricato.cellulare.$invalid
      }
      return retValue
    },
    fieldEmail () {
      let retValue = null
      if (this.submitted) {
        this.$v.incarico.titolare.email.$touch()
        retValue = !this.$v.incarico.titolare.email.$invalid
      }
      return retValue
    },
    fieldEmailIncaricato () {
      let retValue = null
      if (this.submitted) {
        this.$v.incarico.incaricato.email.$touch()
        retValue = !this.$v.incarico.incaricato.email.$invalid
      }
      return retValue
    },
    fieldCodiceFiscale () {
      let retValue = null
      if (this.submitted) {
        this.$v.incarico.titolare.codiceFiscale.$touch()
        retValue = !this.$v.incarico.titolare.codiceFiscale.$invalid
      }
      return retValue
    },
    fieldCodiceFiscaleIncaricato () {
      let retValue = null
      if (this.submitted) {
        this.$v.incarico.incaricato.codiceFiscale.$touch()
        return !this.$v.incarico.incaricato.codiceFiscale.$invalid
      }
      return retValue
    },
    isOpen () {
      return !(this.incarico.stato === 'V')
    },
    urlIncarico () {
      return `/api/incarichi/${this.incarico.id}/download`
    }

  },
  async created () {
    await this.load()
  },

  methods: {
    back () {
      this.$router.push({ name: 'incarichi' })
    },
    async load () {
      try {
        this.loading = true
        let id = this.$route.params.id
        await this.$store.dispatch('incarichi/loadItemById', id)
        let item = this.$store.state.incarichi.item
        // console.log('Incarico item', item)
        if (item.allegati) {
          item.allegati.forEach(x => {
            x.uploaded = ''
          })
        } else {
          this.$set(item, 'allegati', this.allegatiStart())
        }

        if (item.incarico) {
          if (!item.incarico.rappresentante) item.incarico.rappresentante = {}
        }

        this.incarico = item
        this.terminidiUtilizzo = item.terminidiUtilizzo
        this.delegaAllegata()
        // console.log('item caricato nella load', item, this.incarico, this.terminidiUtilizzo)
      } catch (err) {
        this.$ui.showError(err)
        // Se c'è qualsiasi tipo di problema nel caricamento della lista delle dichiarazioni esce comunque.
        this.$router.push({ name: 'home' })
      }
      this.loading = false
    },

    changeAbilitazione: function (val) {
      // console.log('Fine abilitazione', this.incarico.fineAbilitazione)
      if (val !== 'nuova') {
        this.incarico.fineAbilitazione = null
      }
      // console.log('Abilitazione', val, this.incarico.fineAbilitazione)
    },
    changeRappresentante (val) {
      // console.log('Rappresentante', val, this.incarico.incaricato.rappresentante)
      if (val === 'legale') {
        this.incarico.documentazione = 'rappresentanteLegale'
      } else if (val === 'negoziale') {
        this.incarico.documentazione = 'rappresentanteNegoziale'
      }
      this.delegaAllegata()
      // console.log('Abilitazione', val, this.incarico.fineAbilitazione)
    },
    delegaAllegata () {
      let descrizioneDocumenti = this.incarico.allegati[0]
      if (this.incarico.documentazione === 'rappresentanteLegale') {
        // console.log('ciclo in allegati', this.incarico.documentazione)
        descrizioneDocumenti.descrizione = 'Delega rappresentante legale'
      } else if (this.incarico.documentazione === 'rappresentanteNegoziale') {
        descrizioneDocumenti.descrizione = 'Delega rappresentante negoziale'
      }
    },
    handleSubmit () {
      this.submitted = true
      // riassegno all'incarico i nuovi valori dei termini di utilizzo.
      this.incarico.terminidiUtilizzo = this.terminidiUtilizzo
      // console.log('Incarico prima della vberifica', this.incarico)
      if (!this.validate()) {
        this.$ui.notify({
          type: 'warning',
          title: 'Attenzione',
          message: 'I dati inseriti non sono corretti. Controllare gli avvisi ed i campi evidenziati in rosso.'
        })
      } else {
        alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.incarico))
        alert('SUCCESS allegati!! :-)\n\n' + JSON.stringify(this.fileAllegati))
      }
      // console.log('incarico', this.incarico)
      // console.log('allegati', this.fileAllegati)
    },

    async doSaveDraft () {
      try {
        this.loading = true
        // console.log('Richiesta incarico completa da salvare', this.incarico)

        // Salvataggio dei file allegati.
        const formData = new FormData()

        this.incarico.allegati.filter(f => f.fileName).forEach(f => {
          // console.log('f', f, f.idAllegato, this.fileAllegati)
          formData.set(f.idAllegato, this.fileAllegati[f.idAllegato])
          f.fileSelected = ''
        })

        // Aggiorno i "termini di utilizzo"
        this.incarico.terminidiUtilizzo = this.terminidiUtilizzo
        // console.log('this.incarico.terminidiUtilizzo', this.incarico.terminidiUtilizzo)

        formData.set('incarico', JSON.stringify(this.incarico))

        // console.log('Incarico before update', this.incarico)
        // console.log('this.fileAllegati', this.fileAllegati)

        await this.$store.dispatch('incarichi/save', { id: this.incarico.id, formData })

        // console.log('this.$store.state.incarico check item', this.$store.state.incarichi)
        let item = this.$store.state.incarichi.item
        // item.allegati.forEach(x => {
        //   x.uploaded = ''
        // })
        this.isModificato = false
        // console.log('isModificato', this.isModificato)
        this.incarico = item
        this.$ui.notify({
          type: 'success',
          title: 'Esito operazione',
          message: 'Operazione eseguita con successo.'
        })
      } catch (err) {
        this.$ui.showError(err)
      }
      this.loading = false
    },

    doSaveConfirm () {
      let allUploaded = !this.incarico.allegati.some(c => !c.fileName)
      if (!allUploaded) {
        this.$ui.notify({
          type: 'warning',
          title: 'Attenzione',
          message: 'Non sono stati caricati tutti i documenti necessari per poter avviare la procedura.'
        })
      } else {
        this.$ui.notify({
          type: 'confirm',
          title: 'Richiesta di conferma',
          message: 'Una volta salvato, il documento non potrà più essere modificato. Confermi il salvataggio del documento?',
          // okHandler: this.doSaveDraft
          okHandler: this.doSave
        })
      }
    },

    async doSave () {
      try {
        let allUploaded = !this.incarico.allegati.some(c => !c.fileName)
        if (allUploaded) {
          this.loading = true
          this.incarico.stato = 'V'
          // this.item.stato = 'B' // -- SOlo per test

          // Salvataggio dei file allegati.
          const formData = new FormData()

          this.incarico.allegati.filter(f => f.fileName).forEach(f => {
            // console.log('f', f, f.idAllegato, this.fileAllegati)

            formData.set(f.idAllegato, this.fileAllegati[f.idAllegato])
            // f.fileSelected = ''
          })

          formData.set('incarico', JSON.stringify(this.incarico))

          // console.log('this.fileAllegati', this.fileAllegati)

          await this.$store.dispatch('incarichi/save', { id: this.incarico.id, formData })

          let item = this.$store.state.incarichi.item
          item.allegati.forEach(x => {
            x.uploaded = ''
          })

          this.incarico = item
          this.$ui.notify({
            type: 'success',
            title: 'Esito operazione',
            message: `Operazione eseguita con successo.`
          })
        }
      } catch (err) {
        this.incarico.stato = 'B'
        this.$ui.showError(err)
        // back()
      }
      this.loading = false
    },

    doDeleteDraftConfirm () {
      // console.log('Istanza in bozza da eliminare', this.item)

      this.$ui.notify({
        type: 'confirm',
        title: 'Richiesta di conferma',
        message: 'Cancellando la bozza di richiesta incarico saranno eliminati tutti gli eventuali allegati caricati, confermi?',
        okHandler: this.doDeleteDraft
      })
    },

    async doDeleteDraft () {
      this.loading = true
      try {
        await this.$store.dispatch('incarichi/delete', this.incarico)

        this.$ui.notify({
          type: 'success',
          title: 'Esito operazione',
          message: 'Operazione eseguita con successo.'
        })
        this.$router.push({ name: 'incarichi' })
      } catch (err) {
        this.$ui.showError(err)
      }
      this.loading = false
    },

    fieldState (field) {
      let v = this.$v.incarico.titolare[field]
      // console.log('titolare', v.$dirty && v.$error ? false : null)
      return v.$dirty && v.$error ? false : null
    },
    fieldStateIncaricato (field) {
      let v = this.$v.incarico.incaricato[field]
      // console.log('incaricato', v.$dirty && v.$error ? false : null)
      return v.$dirty && v.$error ? false : null
    },
    fieldStateTermini (field) {
      let v = this.$v.terminidiUtilizzo[field]
      // console.log('terminidiUtilizzo', v.$dirty && v.$error ? false : null)
      return v.$dirty && v.$error ? false : null
    },

    close () {
      this.$refs.modal.hide()
    },

    validate () {
      this.$v.$touch()
      return !this.$v.$invalid
    },

    update () {
      // console.log('spunta Update', this.familiare.legami.matrimonio)
      if (!this.validate()) {
        this.$ui.notify({
          type: 'warning',
          title: 'Attenzione',
          message: 'I dati inseriti non sono corretti.'
        })
      } else {
        this.familiare.numeroComponente = this.idx + 1
        this.$set(this.item.nuoviFamiliari, this.idx, this.familiare)
        this.close()
      }
    },

    emptyAllegato () {
      return {
        idAllegato: '',
        descrizione: '',
        fileName: '',
        templateId: 'componenteAggiuntivo',
        uploaded: '',
        codiceFiscale: ''
      }
    },

    allegatiStart () {
      // allegatiStd: [{ 'idAllegato': 'a', 'descrizione': '', 'fileName': '', 'uploaded': '' },
      // { 'idAllegato': 'b', 'descrizione': "Copia documento d'identità", 'fileName': '', 'uploaded': '' }],

      let allegati = []
      let allegatoA = this.emptyAllegato()
      allegatoA.idAllegato = 'a'
      allegatoA.descrizione = ''
      allegatoA.codiceFiscale = ''
      allegatoA.templateId = ''
      allegati.push(allegatoA)

      let allegatoB = this.emptyAllegato()
      allegatoB.idAllegato = 'b'
      allegatoB.descrizione = "Copia documento d'identità"
      allegatoB.codiceFiscale = ''
      allegatoB.templateId = ''
      allegati.push(allegatoB)

      return allegati
    },

    remove () {
      // Rimuovere le relative righe di allegati aggiuntivi.
      // Nel caso vanno rimossi anche i file allegati già uploadati. Va richiesta eventuale conferma.
      if (this.item.nuoviFamiliari.length > 1) {
        // OK posso cancellare le righe corrispondenti al componente (vedi CF)
        let mapIndex = this.item.allegati.map((item, i) => {
          // console.log('mapIndex item', item.codiceFiscale, item)
          return item.codiceFiscale === this.familiare.codiceFiscale ? i : ''
        }).filter(String)
        // console.log('Elementi da cancellare', mapIndex, this.item.allegati, this.familiare.codiceFiscale)
        if (mapIndex.length > 0) {
          this.item.allegati.splice(mapIndex[0], 2)
          this.item.allegati.forEach((element, index, array) => {
            if (index > 3) {
              let appId = this.item.allegati[index - 1].idAllegato
              element.idAllegato = String.fromCharCode(appId.charCodeAt(0) + 1)
            }
          })
        }
      } else {
        // Rimuovere le righe per il primo compponente (a-e)
        this.item.allegati.splice(0, this.item.allegati.length)
      }

      this.item.nuoviFamiliari.splice(this.idx, 1)

      this.close()
    },
    formatUcase (value, event) {
      return value.toUpperCase()
    },
    formatData (value, event) {
      return moment(value).format('YYYY-MM-DDThh:mm:ss').tz('Europe/Rome')
    }
  }
}

</script>

<style lang="stylus" scoped>
.scrollable {
  max-height: max(20rem, 50vh);
  overflow-y: scroll;
}

.large >>> .modal-xl {
  min-width: 60rem !important;
}

.titolo {
  font-weight: bold;
}

#testoCheck {
  margin-left: -26%;
}

#altroTestoCheck {
  margin-left: -18%;
}

.spunta {
  display: block;
}
</style>
